import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';

type ResendRecipientRequestVerificationResponseType = {
  session_id: string;
  status: string;
  phone_masked: string;
};

export const resendRecipientRequestVerificationApi = (
  token: string
): Promise<ApiResponseType<ResendRecipientRequestVerificationResponseType>> => {
  return apiService.POST(`/recipient-requests/${token}/verify/resend/`, {});
};
